import * as URLConfig from "@frameworks/salesjourney/config/domain";
import { microService } from "../microServiceBase";
var downloadURLs = {
    downloadPageList: URLConfig.config.apiBase +
        microService.downloadreportservice +
        "KPIReport/reports",
    downloadFile: URLConfig.config.apiBase +
        microService.downloadreportservice +
        "KPIReport/downloadReport",
};
export default downloadURLs;
